import { Link } from 'react-router';

import type { FC } from 'react';

import { AUTH_ROUTES } from '@/constants/auth';
import { FORBIDDEN_COPY } from '@/constants/forbidden';

import { Button } from 'components/ui/Button';
import { Eyebrow } from 'components/ui/Eyebrow';

const Forbidden: FC = () => (
  <div className="flex flex-1 flex-col items-center justify-center px-12 text-center">
    <Eyebrow>{FORBIDDEN_COPY.eyebrow}</Eyebrow>
    <p className="text-body text-text-primary mt-2">{FORBIDDEN_COPY.headline}</p>
    <Button className="mt-3" asChild>
      <Link to={AUTH_ROUTES.dashboard}>{FORBIDDEN_COPY.backToHome}</Link>
    </Button>
  </div>
);

export {
  Forbidden,
};
